import { render, staticRenderFns } from "./LeavePopup.vue?vue&type=template&id=264b7591&"
import script from "./LeavePopup.vue?vue&type=script&lang=js&"
export * from "./LeavePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports